// ============================================================================
// CONGOLESE (LINGALA) TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Biversé ya Biblia na Lingala na mituya ya Strong

export const bibleVersesRc = [
  {
    reference: "Bafilipo 4:13",
    text: "Nakoki kosala makambo nyonso na nzela ya Klisto oyo azali kopesa ngai makasi",
    version: "Lingala Union Version",
    theme: "Makasi",
    strongNumbers: {
      "nakoki": "G2480", // ἰσχύω (ischyo) = kozala na makasi
      "kopesa ngai makasi": "G1743" // ἐνδυναμόω (endynamoo) = kopesa makasi
    },
    context: "Paulo azali koloba na ntina ya nguya oyo tozwaka na Klisto na makambo nyonso"
  },
  {
    reference: "Banzembo 23:1",
    text: "Yawe azali Mobateli na ngai, nakozanga eloko te",
    version: "Lingala",
    theme: "Kondima",
    strongNumbers: {
      "Mobateli": "H7462", // רָעָה (ra'ah) = mobateli ya mpata
      "nakozanga": "H2637" // חָסֵר (chaser) = kozanga
    },
    context: "Davidi azali komonisa kondima na ye na boye Nzambe azali kobatela biso"
  },
  {
    reference: "Yoane 3:16",
    text: "Pamba te Nzambe alingaki mokili boye ate apesaki Mwana na Ye ya moko, mpo ete moto nyonso oyo akondima na Ye abeba te, kasi azala na bomoi ya seko",
    version: "Lingala Union Version",
    theme: "Bolingo",
    strongNumbers: {
      "alingaki": "G25", // ἀγαπάω (agapao) = kolinga na kondima te
      "apesaki": "G1325", // δίδωμι (didomi) = kopesa
      "ya seko": "G166" // αἰώνιος (aionios) = ya seko
    },
    context: "Yesu azali komonisa bolingo ya Nzambe oyo ezali na ndelo te mpo na biso"
  },
  {
    reference: "Baroma 8:28",
    text: "Toyebi ete makambo nyonso esalemaka mpo na bolamu ya baoyo balingaka Nzambe, oyo babengami kolanda mokano na Ye",
    version: "Lingala Union Version",
    theme: "Bobateli",
    strongNumbers: {
      "esalemaka": "G4903", // συνεργέω (synergeo) = kosala elongo
      "bolamu": "G18" // ἀγαθός (agathos) = malamu
    },
    context: "Paulo azali kondimisa bokonzi ya Nzambe na mokano na Ye"
  },
  {
    reference: "Masese 3:5-6",
    text: "Tya motema na Yawe na motema na yo mobimba, mpe kotia elikya na bwanya na yo moko te. Yeba Ye na banzela na yo nyonso, mpe Ye akotambwisa yo malamu",
    version: "Lingala",
    theme: "Bwanya",
    strongNumbers: {
      "Tya motema": "H982", // בָּטַח (batach) = kotya motema
      "bwanya": "H998", // בִּינָה (binah) = boyebi
      "akotambwisa": "H3474" // יָשַׁר (yashar) = kosala sembo
    },
    context: "Salomo azali kolendisa biso kotya motema na Nzambe koleka bwanya na biso moko"
  },
  {
    reference: "Yizayi 40:31",
    text: "Kasi baoyo bazali kozela Yawe bakozonga na makasi, bakopumbwa na mapapu lokola mpongo, bakokima mpe balembaka te, bakotambola mpe bakozala na mpasi te",
    version: "Lingala",
    theme: "Kobongwana",
    strongNumbers: {
      "bazali kozela": "H6960", // קָוָה (qavah) = kozela
      "bakozonga": "H2498", // חָלַף (chalaph) = kobongwana
      "makasi": "H3581" // כֹּחַ (koach) = nguya
    },
    context: "Yizayi azali kolaka kobongwana ya molimo mpo na baoyo bazali kozela Yawe"
  },
  {
    reference: "Matai 11:28",
    text: "Boya epai na ngai bino nyonso oyo bozali na mpasi mpe bomemi mikumba, mpe ngai nakopesa bino bopemi",
    version: "Lingala Union Version",
    theme: "Bopemi",
    strongNumbers: {
      "bozali na mpasi": "G2872", // κοπιάω (kopiao) = kozala na mpasi
      "bomemi mikumba": "G5412", // φορτίζω (phortizo) = komema mokumba
      "nakopesa bino bopemi": "G373" // ἀναπαύω (anapauo) = kopesa bopemi
    },
    context: "Yesu azali kopesa libyangi ya mawa mpo na baoyo nyonso bazali na mpasi"
  }
];

export default bibleVersesRc;
